import React from 'react'

const Procedure = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Procedure followed in the Decision Making Process</h5>
    </div>

    <div className="about-box p-4 rounded shadow-lg " style={{textAlign:'justify'}}>
      <p>Different powers have been delegated by the Board of Directors to its officers at various levels for performing their duties. In order to exercise supervision and fix responsibility, various control measures are in force.</p>
    </div>
    </div>
  )
}

export default Procedure
